import React from 'react';
import DisplayValue from './display-value';
import styles from './styles.cssm';

/* eslint-disable-next-line complexity */
const NutritionFact = ({
  caffeineDisclaimerId,
  caffeineElementId,
  disclaimerTitleId,
  fact,
  isSubfact = false,
}) => {
  const CAFFEINE_KEY = 'Caffeine';
  const CAFFEINE_KEY_FR_CA = 'Caféine';
  const CAFFEINE_RANGE_KEY = 'Caffeine Range';
  const CAFFEINE_RANGE_KEY_FR_CA = 'Gamme de Caféine';

  const { id, displayName, displayValue, dailyValue, subfacts } = fact;
  const textClass = !isSubfact ? 'text-semibold' : 'color-textBlackSoft';
  const dailyValueTextClass = !isSubfact ? 'text-semibold' : '';
  const isCaffeine =
    displayName === CAFFEINE_KEY || displayName === CAFFEINE_KEY_FR_CA;
  const caffeineRangeMax =
    fact?.maximum?.displayName === CAFFEINE_RANGE_KEY ||
    fact?.maximum?.displayName === CAFFEINE_RANGE_KEY_FR_CA
      ? fact?.maximum?.value
      : null;
  const caffeineRangeMaxUnits =
    fact?.maximum?.displayName === CAFFEINE_RANGE_KEY ||
    fact?.maximum?.displayName === CAFFEINE_RANGE_KEY_FR_CA
      ? fact?.maximum?.unitOfMeasure
      : null;

  const OuterTagName = subfacts ? 'ul' : 'div';
  const InnerTagName = subfacts ? 'li' : 'div';
  return (
    <li key={id}>
      <OuterTagName>
        <InnerTagName
          className={isSubfact ? styles.subContainer : styles.container}
        >
          <span>
            <span className={`${textClass} pr1`}>{displayName}</span>
            <DisplayValue
              caffeineDisclaimerId={caffeineDisclaimerId}
              caffeineElementId={caffeineElementId}
              caffeineRangeMax={caffeineRangeMax}
              caffeineRangeMaxUnits={caffeineRangeMaxUnits}
              className={textClass}
              disclaimerTitleId={disclaimerTitleId}
              displayValue={displayValue}
              isCaffeine={isCaffeine}
            />
          </span>
          <span className={dailyValueTextClass}>{dailyValue}</span>
        </InnerTagName>
        {subfacts
          ? subfacts.map((subfact, index) => (
              <NutritionFact
                fact={subfact}
                isSubfact
                key={`subfact-${index}`}
              />
            ))
          : null}
      </OuterTagName>
    </li>
  );
};

export default NutritionFact;
